/* eslint-disable complexity */
import React from 'react'
import { List } from 'antd'
import { Project } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { ProjectDetailsCollapse } from '../index'
import { CustomText, CustomLink } from 'src/components'
import styles from './ProjectDetailsCertification.module.scss'
import { certificationSections } from './certification.sections'
import ProjectDetailsLogoStandard from './ProjectDetailsLogoStandard/ProjectDetailsLogoStandard'

const ProjectDetailsCertification: React.FC<{ project: Project }> = ({ project }) => {
  const { t } = useTranslation()

  return (
    <ProjectDetailsCollapse label={<CustomText label={t('Projects.Fields.Certification')} strong />}>
      {/* Logo Standard */}
      {project.standard && <ProjectDetailsLogoStandard standard={project.standard} />}

      {/* Project Certification Details List */}
      <div className={styles.content} style={{ marginTop: project.standard ? '-50px' : '-30px' }}>
        <List dataSource={certificationSections(project, t)}
          renderItem={item => {
            if (!item.show) return
            return (
              <List.Item>
                <React.Fragment>
                  <CustomText label={item.label} />
                  {item?.isLink ? (
                    <CustomLink
                      label={t('Projects.CheckitHere')}
                      link={item.value}
                      showIcon={false}
                      isSmallText
                      icon={null}
                      isStrong
                    />
                  ) : (
                    <CustomText
                      label={item.value || '-'}
                      strong
                    />
                  )}
                </React.Fragment>
              </List.Item>
            )
          }}
        />
      </div>
    </ProjectDetailsCollapse>
  )
}

export default ProjectDetailsCertification
